<template>
  <div class="container-fluid tester-window"> {{ condition }}
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Payload</label>
        <Editor v-model="payload" :textarea="true" class="ch100" />
      </div>
      <div class="col-md-4 mb-2">
        <div class="mb-2">Condition</div>
        <div v-html="'{{ if'"></div>

        <v-text-field
          outlined
          dense
          hide-details="auto"
          :value="condition"
          v-model="condition"
        />
        <div v-html="'}}'"></div>
        <br />
        condition true, step will be executed<br />
        <div v-html="'{{ else }}'"></div>
        <br />
        condition false, step will be skipped<br />
        <div v-html="'{{ end }}'"></div>
      </div>
      <div class="col-md-4 mb-2">
        <label>Output</label>
        <Editor v-model="out" :textarea="true" class="ch100" />
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/API/';
import debounce from "lodash.debounce";

export default {
  name: "ConditionTester",
  props: {
    input: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {
    Editor: () => import("@/components/Editor.vue"),
  },
  computed: {
    condition: {
      get() {
        return this.value;
      },
      set(v) {
        this.resend(v, this.pl, this);
        this.$emit("condition-input", v);
      },
    },
    payload: {
      get() {
        return this.input;
      },
      set(v) {
        this.pl = v;
        this.resend(this.value, v, this);
      },
    },
  },
  data: () => {
    return {
      out: "",
      pl: "",
    };
  },
  methods: {
    resend: debounce((v, i, self) => {
      // intercept the Tr (v) value here to modify it for testing ONLY

      const preConvertValue = `{{ if ${v} }} OK {{ else }} NOT OK {{ end }}`;

      request
        .post("/editor/convert", { Tr: preConvertValue, In: i })
        .then((res) => {
          if (typeof res.data != "string") {
            self.out = JSON.stringify(res.data, undefined, " ");
          } else {
            self.out = res.data;
          }
        });
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
::v-deep .editor.editor__textarea {
  height: calc(100vh - 134px) !important;
  width: 100% !important;
}
</style>

